<button
  (click)="onClick($event)"
  [attr.aria-label]="label"
  [class]="cssClass"
  [color]="color"
  [disabled]="disabled"
  [type]="type"
  mat-raised-button>
  @if (icon) {
    <mat-icon aria-hidden="true" class="mr-1">{{ icon }}</mat-icon>
  }
  <span class="breaking-text">{{ label }}</span>
</button>
